import { continentLabel } from "./useBangXepHangFifa";

function formatChange(n) {
  const v = Number(n);
  if (Number.isNaN(v) || v === 0) return "0";
  return v > 0 ? `+${v}` : String(v);
}

/**
 * @param {object} props
 * @param {object[]} props.rows
 * @param {number} props.total
 * @param {number} props.visibleItems
 * @param {boolean} props.canLoadMore
 * @param {() => void} props.onLoadMore
 */
export default function FifaRankingTable({
  rows,
  total,
  visibleItems,
  canLoadMore,
  onLoadMore,
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="bg-[var(--background-header)] md:rounded border border-[var(--bxh-border)] overflow-hidden">
        <div className="overflow-x-auto league-standing-scrollbar-hide">
          <table className="w-full text-[13px] table-fixed min-w-[520px]">
            <thead className="bg-[var(--surface-row-alt2)]">
              <tr className="h-[37px]">
                <th className="w-12 pl-3 pr-2 text-left kbv-bxh-fg font-semibold text-xs">
                  #
                </th>
                <th className="text-left kbv-bxh-fg font-semibold text-xs pr-2">
                  Tuyển Quốc Gia
                </th>
                <th className="w-[88px] md:w-[110px] text-center kbv-bxh-fg font-semibold text-xs">
                  Khu Vực
                </th>
                <th className="w-16 md:w-20 text-center kbv-bxh-fg font-semibold text-xs">
                  Điểm
                </th>
                <th className="w-14 md:w-16 text-center kbv-bxh-fg font-semibold text-xs">
                  HS
                </th>
                <th className="w-[72px] md:w-24 text-center kbv-bxh-fg font-semibold text-xs pr-3">
                  Điểm trước
                </th>
              </tr>
            </thead>
            <tbody className="kbv-bxh-fg">
              {rows.map((item, index) => {
                const team = item.teams;
                const name =
                  team?.nameVi || team?.name || item.teamName || "-";
                const prev = Number(item.score) - Number(item.scoreChange || 0);
                const change = Number(item.scoreChange);

                return (
                  <tr
                    key={item.id ?? `${item.teamId}-${index}`}
                    className="h-[40px] border-t border-[var(--bxh-border)] hover:bg-[var(--bxh-row-hover)]"
                  >
                    <td className="pl-3 pr-2 align-middle">
                      <span className="inline-flex w-6 h-6 items-center justify-center rounded text-[10px] lg:text-xs font-bold shrink-0 bg-[var(--bxh-badge-bg)] kbv-bxh-badge">
                        {index + 1}
                      </span>
                    </td>
                    <td className="pr-2 align-middle max-w-0">
                      <div className="flex items-center gap-1.5 min-w-0">
                        {team?.logo ? (
                          <img
                            src={team.logo}
                            alt=""
                            width={20}
                            height={20}
                            className="w-5 h-5 object-contain shrink-0"
                          />
                        ) : null}
                        <span
                          title={name}
                          className="block truncate text-xs lg:text-sm min-w-0 flex-1"
                        >
                          {name}
                        </span>
                      </div>
                    </td>
                    <td className="text-center align-middle text-xs font-semibold text-[var(--bxh-primary)]">
                      {continentLabel(item.continent)}
                    </td>
                    <td className="text-center align-middle font-bold">
                      {item.score}
                    </td>
                    <td
                      className={`text-center align-middle font-bold ${
                        change > 0
                          ? "kbv-bxh-c-win"
                          : change < 0
                            ? "kbv-bxh-c-lose"
                            : ""
                      }`}
                    >
                      {formatChange(item.scoreChange)}
                    </td>
                    <td className="text-center align-middle font-bold pr-3">
                      {Number.isNaN(prev) ? "-" : prev}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {canLoadMore ? (
        <button
          type="button"
          onClick={onLoadMore}
          className="kbv-bxh-load-more mx-auto mt-1 px-3 py-2 rounded text-xs font-semibold uppercase hover:brightness-95"
        >
          ({visibleItems}/{total}) Xem thêm +20
        </button>
      ) : null}
    </div>
  );
}
